import { Link } from 'react-router-dom';

interface SharedFinalCTAProps {
  headline?: string;
  headlineAccent?: string;
  subtext?: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
  offer?: string;
  urgency?: string;
  bgImage?: string;
}

export default function SharedFinalCTA({
  headline = 'Fix Your Board in Minutes',
  headlineAccent = 'Not Days.',
  subtext = "Sun-powered repair kits trusted by 40,000+ surfers worldwide. Don't miss your next session.",
  primaryLabel = 'Shop Kits Now',
  primaryTo = '/products',
  secondaryLabel = 'How It Works',
  secondaryTo = '/#how-it-works',
  offer = 'Free Micro Kit with orders over $40',
  urgency = "Don't let a ding decide whether you surf today.",
  bgImage = 'https://public.readdy.ai/ai/img_res/33a1b10eff6aa4e9b80cf63e62ac06ee.jpg',
}: SharedFinalCTAProps) {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={bgImage} alt="Surf lifestyle" className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B2C26]/85 to-[#0B2C26]/95" />
      </div>
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
        <div className="w-16 h-16 rounded-full bg-[#FF6B35]/20 border border-[#FF6B35]/40 flex items-center justify-center mx-auto mb-6">
          <i className="ri-sun-fill text-[#FF6B35] text-3xl" />
        </div>
        <h2 className="text-4xl md:text-6xl font-black text-white mb-2 leading-tight">
          {headline}
        </h2>
        <h2 className="text-4xl md:text-6xl font-black text-[#FF6B35] mb-5 leading-tight">
          {headlineAccent}
        </h2>
        <p className="text-white/70 text-lg md:text-xl mb-4 max-w-xl mx-auto leading-relaxed">{subtext}</p>
        {urgency && (
          <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 border border-[#FF6B35]/30 rounded-full px-4 py-2 mb-8">
            <i className="ri-alarm-warning-line text-[#FF6B35] text-sm" />
            <span className="text-[#FF6B35] text-sm font-semibold">{urgency}</span>
          </div>
        )}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
          <Link to={primaryTo} className="whitespace-nowrap bg-[#FF6B35] text-white font-black text-lg px-10 py-5 rounded-full hover:bg-[#e55a25] transition-all cursor-pointer flex items-center gap-3">
            {primaryLabel}
            <i className="ri-arrow-right-line" />
          </Link>
          {secondaryLabel && (
            <a href={secondaryTo} className="whitespace-nowrap border-2 border-white/40 text-white font-bold text-base px-8 py-5 rounded-full hover:bg-white/10 transition-all cursor-pointer">
              {secondaryLabel}
            </a>
          )}
        </div>
        {offer && (
          <p className="text-[#FF6B35] font-semibold text-sm flex items-center justify-center gap-2 mb-8">
            <i className="ri-gift-line" />
            {offer}
          </p>
        )}
        <div className="flex flex-wrap gap-6 justify-center">
          {['UV Sun-Cure Technology', 'Free Shipping $50+', 'Trusted by 40K+ Surfers'].map((item) => (
            <div key={item} className="flex items-center gap-2 text-white/50 text-sm">
              <i className="ri-check-line text-[#FF6B35]" />
              {item}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
